import secureLocalStorage from 'react-secure-storage';
import { saveLocationData } from './apiUtils'; // Import the new utility function

export const getLocationAndSave = async (
  setLatitude,
  setLongitude,
  setAccuracy,
  setTimestamp,
  // setViewport,
  player,
  hooks = {},
) => {
  // Opt-in only: legacy callers retain their existing side effects and result.
  const isCurrent = (position) => !hooks?.isCurrent || hooks.isCurrent(position);
  const options = {
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 0,
  };

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        if (!isCurrent(position)) return resolve(null);
        const { latitude, longitude, accuracy } = position.coords;
        const timestamp = position.timestamp;

        setLatitude(latitude);
        setLongitude(longitude);
        setAccuracy(accuracy);
        setTimestamp(timestamp);
        // setViewport((prevViewport) => ({
        //   ...prevViewport,
        //   latitude,
        //   longitude,
        // }));

        // console.log(latitude, longitude);
        if (!isCurrent(position)) return resolve(null);
        secureLocalStorage.setItem('latitude', JSON.stringify(latitude));
        secureLocalStorage.setItem('longitude', JSON.stringify(longitude));

        if (!isCurrent(position)) return resolve(null);
        hooks?.onPermissionGranted?.(position);
        if (!isCurrent(position)) return resolve(null);
        hooks?.onSaveAttempted?.(position);
        if (!isCurrent(position)) return resolve(null);
        try {
          await saveLocationData(
            latitude,
            longitude,
            accuracy,
            timestamp,
            player.token,
          );
          if (!isCurrent(position)) return resolve(null);
          hooks?.onSaved?.(position);
        } catch (err) {
          if (!isCurrent(position)) return resolve(null);
          hooks?.onSaveFailed?.(err);
          console.error('Error saving location:', err.message);
        }

        resolve(isCurrent(position) ? position : null);
      },
      (error) => {
        if (!isCurrent()) return resolve(null);
        const permissionDenied =
          error?.code === 1 || error?.code === error?.PERMISSION_DENIED;
        if (!permissionDenied) {
          console.error('Error getting location:', error);
        }
        reject(error);
      },
      options,
    );
  });
};
